import FeatureBar from './FeatureBar'

export default FeatureBar
